module.exports = __webpack_public_path__ + "img/42_27.3461f23d.png";